import { Note } from "./Note";
export default Note;